import * as React from 'react'
import * as _ from 'lodash'
import styled from 'styled-components'
import { graphql, StaticQuery } from 'gatsby'
import { Button } from 'antd'

const StyledZipViewer = styled.div`
  ${({ theme }) => `
  text-align: center;
  margin-top: ${theme['margin-lg']};
  margin-bottom: ${theme['margin-lg']};
  padding-top: ${theme['padding-med']};
  padding-bottom: ${theme['padding-med']};
  background-color: ${theme['background']};
  border-radius: ${theme['border-radius']};
`}
`

export const ZipViewer = ({
  zipName,
  header,
}: {
  zipName: string
  header: string
}) => (
  <StaticQuery
    query={graphql`
      {
        site {
          siteMetadata {
            siteUrl
          }
        }
        allFile(filter: { extension: { eq: "zip" } }) {
          edges {
            node {
              publicURL
              name
            }
          }
        }
      }
    `}
    render={data => {
      const zipUrl = data.allFile.edges.find(n => {
        return n.node.name.includes(zipName)
      })
      const { siteUrl } = data.site.siteMetadata
      const publicURL = _.get(zipUrl, 'node.publicURL')
      if (!publicURL) {
        return null
      }

      return (
        <StyledZipViewer>
          <h4>{header}</h4>
          <a href={siteUrl + publicURL}>
            <Button type="primary" shape="round" icon="download" size={'large'}>
              Download
            </Button>
          </a>
        </StyledZipViewer>
      )
    }}
  />
)
